<div class="modal fade document-permissions-modal" [id]="modalId" msEscClose (escPressed)="cancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title text-break">
                    @if (targets().length === 1) {
                        Change permissions for "{{ targets()[0].name }}"
                    } @else if (targets().length > 1) {
                        Change permissions for {{ targets().length }} folders
                    } @else {
                        Change permissions
                    }
                </h5>
            </div>

            <div class="modal-body px-4 pb-0">
                <p class="text-secondary mb-3">Select who can access these folders. Files inside inherit the folder's permission.</p>

                <div class="permission-options">
                    <button type="button" class="permission-option ms-selectable-card"
                        [class.is-selected]="selectedLevel() === DocumentPermission.AdminOnly"
                        (click)="chooseLevel(DocumentPermission.AdminOnly)">
                        <div class="option-icon admin-only-icon">
                            <fa-duotone-icon icon="lock" secondaryOpacity="0.4" />
                        </div>
                        <div class="option-content">
                            <div class="option-title">{{ getLevelLabel(DocumentPermission.AdminOnly) }}</div>
                            <div class="option-description">{{ getLevelDescription(DocumentPermission.AdminOnly) }}</div>
                        </div>
                        @if (selectedLevel() === DocumentPermission.AdminOnly) {
                            <fa-duotone-icon icon="circle-check" class="text-primary option-check" secondaryOpacity="0.4" />
                        }
                    </button>

                    <button type="button" class="permission-option ms-selectable-card"
                        [class.is-selected]="selectedLevel() === DocumentPermission.MemberRead"
                        (click)="chooseLevel(DocumentPermission.MemberRead)">
                        <div class="option-icon member-read-icon">
                            <fa-duotone-icon icon="users" secondaryOpacity="0.4" />
                        </div>
                        <div class="option-content">
                            <div class="option-title">{{ getLevelLabel(DocumentPermission.MemberRead) }}</div>
                            <div class="option-description">{{ getLevelDescription(DocumentPermission.MemberRead) }}</div>
                        </div>
                        @if (selectedLevel() === DocumentPermission.MemberRead) {
                            <fa-duotone-icon icon="circle-check" class="text-primary option-check" secondaryOpacity="0.4" />
                        }
                    </button>

                    <button type="button" class="permission-option ms-selectable-card"
                        [class.is-selected]="selectedLevel() === DocumentPermission.Public"
                        (click)="chooseLevel(DocumentPermission.Public)">
                        <div class="option-icon public-link-icon">
                            <fa-duotone-icon icon="globe" secondaryOpacity="0.4" />
                        </div>
                        <div class="option-content">
                            <div class="option-title">{{ getLevelLabel(DocumentPermission.Public) }}</div>
                            <div class="option-description">{{ getLevelDescription(DocumentPermission.Public) }}</div>
                        </div>
                        @if (selectedLevel() === DocumentPermission.Public) {
                            <fa-duotone-icon icon="circle-check" class="text-primary option-check" secondaryOpacity="0.4" />
                        }
                    </button>
                </div>

                @if (failures().length > 0) {
                    <div class="failure-panel mt-4 pt-3 border-top">
                        <div class="d-flex align-items-start gap-2">
                            <fa-duotone-icon icon="triangle-exclamation" class="text-warning mt-1" secondaryOpacity="0.4" />
                            <div class="flex-grow-1">
                                <strong>{{ failures().length }} folder(s) could not be updated:</strong>
                                <ul class="failure-list mt-2 small mb-0">
                                    @for (f of failures(); track f.folderName) {
                                        <li>
                                            <strong>{{ f.folderName }}</strong> — {{ f.message }}
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4 gap-2">
                <button type="button" class="btn btn-ms-secondary px-4" (click)="cancel()" [disabled]="isSubmitting()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary px-4" (click)="submit()" [disabled]="isSubmitting()">
                    @if (isSubmitting()) {
                        <span class="spinner-border spinner-border-sm me-2"></span>
                    }
                    Save changes
                </button>
            </div>
        </div>
    </div>
</div>
